import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

export const GoingBackCheckSubform = () => {
  // Hooks
  const { t } = useTranslation();

  return (
    <Grid
      justify="center"
      className="common-notice-container"
      direction="column"
      spacing={2}
      container
    >
      <Typography className="common-notice-paragraph">
        {t(`By clicking "Yes" you will be taken back to the "Confirm Experience" page. Answers you previously provided will be shown as pre-selected in the form and you will be able to modify these.`)}
      </Typography>

      <Typography className="common-notice-paragraph">
        {t(`By clicking "No" you will continue with the investment process.`)}
      </Typography>
    </Grid>
  );
};
